/**
 * Utility functions for organization-related operations
 */

const ORGANIZATION_MAPPING = {
  'drrobertmelillo.neuroelpis.com': 'USA',
  'colombia.neuroelpis.com': 'Colombia',
  'australia.neuroelpis.com': 'Australia',
};

/**
 * Get the organization name based on the current hostname
 * Supports override via REACT_APP_ORG_OVERRIDE environment variable for testing
 * @returns {string|null} The organization name or null if not found
 */
export function getOrganizationFromHostname() {
  if (process.env.REACT_APP_ORG_OVERRIDE) {
    const override = process.env.REACT_APP_ORG_OVERRIDE.trim();
    const validOrganizations = Object.values(ORGANIZATION_MAPPING);
    if (validOrganizations.includes(override)) {
      return override;
    }
  }

  const hostname = window.location.hostname;
  return ORGANIZATION_MAPPING[hostname] || null;
}

/**
 * Get the organization name with a fallback to a default value
 * @param {string} defaultValue - The default value if no organization is found
 * @returns {string} The organization name or the default value
 */
export function getOrganizationOrDefault(defaultValue = '') {
  return getOrganizationFromHostname() || defaultValue;
}

export default {
  getOrganizationFromHostname,
  getOrganizationOrDefault,
};
